import { Sparkles } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function AnalysingPlaceholder({ title = false }: { title?: boolean }) {
    return (
        <div
            aria-busy="true"
            className={cn(
                "flex cursor-not-allowed select-none items-center gap-2",
                title
                    ? "heading-3 w-full min-w-0 px-1 py-2 text-zinc-900"
                    : "h-9 w-full flex-1 rounded-md border border-zinc-200 bg-white px-3 text-sm shadow-xs",
            )}
        >
            <Sparkles className="size-3.5 shrink-0 animate-analysing-twinkle text-blue-500" />
            <span className="animate-analysing-shimmer bg-[length:200%_100%] bg-[linear-gradient(90deg,#a1a1aa_0%,#d4d4d8_40%,#a1a1aa_80%)] bg-clip-text text-transparent">
                Analysing...
            </span>
        </div>
    );
}

export function AnalysingValue({
    analysing,
    title = false,
    children,
}: {
    analysing: boolean;
    title?: boolean;
    children: ReactNode;
}) {
    if (analysing) return <AnalysingPlaceholder title={title} />;
    return children;
}
